<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__address">
    <div class="">
      <div class="side__modal__content fixed-modal-content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">Добавление адреса</h3>
            <span class="modal__close" @click="closeModal"><svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer" @submit="submit" :initial-values="addressForm" :validation-schema="addressSchema">
          <div class="row">

            <div class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="region-input" class="label">{{ $lang.app.REGION }}</label>
                <div class="select__wrapper">
                  <Field name="regionId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="region-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="addressForm.regionId"
                        :options="regions"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div v-if="districts.length" class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="district-input" class="label">{{ $lang.app.DISTRICT }}</label>
                <div class="select__wrapper">
                  <Field name="districtId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="district-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="addressForm.districtId"
                        :options="districts"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div v-if="aymaks.length" class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="aymak-input" class="label">{{ $lang.app.AIMAK }}</label>
                <div class="select__wrapper">
                  <Field name="aymakId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="aymak-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="addressForm.aymakId"
                        :options="aymaks"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div v-if="villages.length" class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="village-input" class="label">{{ $lang.app.VILLAGE }}</label>
                <div class="select__wrapper">
                  <Field name="villageId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="village-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="addressForm.villageId"
                        :options="villages"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div v-if="streets.length" class="col-lg-6">
              <div class="input__group input__add__info">
                <label for="street-input" class="label">{{ $lang.app.STREET }}</label>
                <div class="select__wrapper">
                  <Field name="streetId" v-slot="{ field, errorMessage }">
                    <Multiselect
                        id="street-input"
                        :class="{'select--fail': errorMessage }"
                        v-bind="field"
                        v-model="addressForm.streetId"
                        :options="streets"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="id"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND"
                        :can-clear="false">
                    </Multiselect>
                    <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                  </Field>
                </div>
              </div>
            </div>
            <div v-if="!streets.length" class="col-lg-6">
              <div class="input__group">
                <label for="street-txt-input" class="label">{{ $lang.app.STREET }}</label>
                <Field
                    name="streetTxt"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="text"
                         id="street-txt-input"
                         class="input"
                         v-model="addressForm.streetTxt"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="uchnum-input" class="label">{{ $lang.app.UCHNUM }}</label>
                <Field
                    name="uchnum"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="text"
                         id="uchnum-input"
                         class="input"
                         v-model="addressForm.uchnum"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="house-txt-input" class="label">{{ $lang.app.HOUSE }}</label>
                <Field
                    name="houseTxt"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="text"
                         id="house-txt-input"
                         class="input"
                         v-model="addressForm.houseTxt"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="flat-txt-input" class="label">{{ $lang.app.FLOOR }}</label>
                <Field
                    name="flatTxt"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="number"
                         id="flat-txt-input"
                         class="input"
                         v-model="addressForm.flatTxt"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>

          </div>
          <div class="between__buttons">
            <button type="button" class="button button--cancel" @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.SAVE }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate'
import addressApi from "../../api/address"
import * as yup from "yup";

export default {
  name: 'AddressModal',
  components: {
    Field,
    Form,
  },
  data() {
    return {
      showModal: false,
      submitting: false,

      regions: [],
      districts: [],
      aymaks: [],
      villages: [],
      streets: [],
      addressForm: {
        regionId: null,
        districtId: null,
        aymakId: null,
        villageId: null,
        streetId: null,
        streetTxt: '',
        uchnum: '',
        houseTxt: '',
        flatTxt: '',
      },
      addressSchema: yup.object({
        regionId: yup.mixed().required()
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-address-modal', () => {
      this.getRegions()
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-address-modal')
  },
  watch: {
    'addressForm.regionId'(value) {
      this.addressForm.districtId = null;
      this.addressForm.aymakId = null;
      this.addressForm.villageId = null;
      this.addressForm.streetId = null;
      this.districts = [];
      this.aymaks = [];
      this.villages = [];
      this.streets = [];
      if (value) {
        this.getChildren(value)
        this.getStreets(value)
      }
    },
    'addressForm.districtId'(value) {
      this.addressForm.aymakId = null;
      this.addressForm.villageId = null;
      this.addressForm.streetId = null;
      this.aymaks = [];
      this.villages = [];
      this.streets = [];
      if (value) {
        this.getChildren(value)
        this.getStreets(value)
      }
    },
    'addressForm.aymakId'(value) {
      this.addressForm.villageId = null;
      this.addressForm.streetId = null;
      this.villages = [];
      this.streets = [];
      if (value) {
        this.getChildren(value)
        this.getStreets(value)
      }
    },
    'addressForm.villageId'(value) {
      if (value) {
        this.getStreets(value)
      }
    }
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },

    getRegions() {
      let self = this;
      addressApi.getRegions()
          .then(function (response) {
            self.setAddressOptions(response.data)
          }).catch(error => {
        console.log(error);
      })
    },
    getChildren(id) {
      let self = this;
      addressApi.getChildren(id)
          .then(function (response) {
            self.setAddressOptions(response.data)
          }).catch(error => {
        console.log(error);
      })
    },
    getStreets(id) {
      let self = this;
      addressApi.getStreet(id)
          .then(function (response) {
            if (response.data.length) {
              self.streets = response.data.map(item => {
                return {
                  id: item.id,
                  label: item.name
                }
              })
            }
          }).catch(error => {
        console.log(error);
      })
    },
    setAddressOptions(data) {
      if (data.length > 0) {
        switch (data[0].type) {
          case 5:
          case 2:
            this.regions = this.getParsed(data)
            break;
          case 3:
          case 6:
            this.districts = this.getParsed(data);
            break;
          case 4:
          case 7:
          case 101:
            this.aymaks = this.getParsed(data)
            break;
          default:
            this.villages = this.getParsed(data)
            break;
        }
      }
    },
    getParsed(data) {
      return data.map(item => {
        return {
          id: item.id,
          label: item.name
        }
      })
    },

    submit() {
      this.submitting = true
      addressApi.saveAddress(this.addressForm)
          .then(response => {
            this.closeModal()
            this.$emit('set-address', response.data.id, response.data.address);
          })
          .catch(error => {
            console.log(error);
          }).finally(() => {
            this.submitting = false
          })
    }
  }
}
</script>
